import { Component, Input, OnInit } from '@angular/core';
import { Cluster, Common, ExtClusterAnalytics } from 'app/models/ext-cluster-analytics.model';
import { CustomersService } from 'app/services/customer/customers.service';

@Component({
  selector: 'app-ext-cluster-analytics',
  templateUrl: './ext-cluster-analytics.component.html',
  styleUrls: ['./ext-cluster-analytics.component.css']
})
export class ExtClusterAnalyticsComponent implements OnInit {
  @Input() customerHostId;

  extClusterAnalytics: ExtClusterAnalytics;
  clusters: Cluster[];
  common: Common;

  constructor(private customerService: CustomersService) { }

  ngOnInit() {
    this.customerService.getExtClusterAnalytics(this.customerHostId).subscribe((res: ExtClusterAnalytics)=> {
      if (res.j_value.clusters[0] == null) {
        this.clusters = [];
      } else {
        this.clusters = res.j_value.clusters;
      }
      this.common = res.j_value.common;    
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/ext-cluster-analytics/ext-cluster-analytics.component.ts